import {
    Card,
    CardContent,
    CircularProgress,
    TextField,
    Grid,
    Button,
    Divider
  } from '@material-ui/core';
  import { makeStyles } from '@material-ui/styles';
  import clsx from 'clsx';
  import React, { useState, useEffect } from 'react';
  import 'react-confirm-alert/src/react-confirm-alert.css';
  import { useTranslation } from 'react-i18next';
  import { connect } from 'react-redux';
  import axios from 'src/utils/axios';
  import { getUser } from 'src/utils/Common';
  import RepeatOneIcon from '@material-ui/icons/RepeatOne';
  import moment from 'moment';
  import Alert from 'src/components/Alert';
  import { resetMaterials, getMaterialRequest } from 'src/store/actions';

  
  const useStyles = makeStyles(theme => ({
    root: {
      color: 'white'
    },
    buttonSuccess: {
      position: 'relative',
      float: 'right',
      marginBottom: 10,
      marginLeft: 'auto',
      color: 'white',
      backgroundColor: '#1D3343',
      '&:hover': {
        backgroundColor: '#2f5f82'
      }
    },
    content: {
      minHeight: 130,
      minWidth: 530
    },
    wrapper: {
      '& > div:not(:last-child)': {
        marginBottom: 16
      },
      position: 'relative'
    }
  }));

function SerialNumberParse({className,SKU,MODEL,BRANDCODE,PRODUCTID,GetHistoricalBom})
{
    const classes = useStyles();
    const { t } = useTranslation('work_order');
    const [ProductYear, setProductYear] = useState('');
    const [ProductMonth, setProductMonth] = useState('');
    const [SerialNumber, setSerialNumber] = useState('');
    const [uyariCiktiNote, setUyariCiktiNote] = useState(false);
    const [uyariAciklamaNote, setUyariAciklamaNote] = useState('');
    const [Required, setRequired] = React.useState(false);
    const [uyariTipCiktiNote, setUyariTipCiktiNote] = useState();
    const SessionUser = getUser();
    const [loading, setLoading] = useState(false);
    const [SerialParam, setSerialParam] = React.useState('');
    

    function calculateSerialNumberYear(yearRule, serialNumber) {
        if (yearRule == null || yearRule == undefined) {
          return null
        }
        else if (yearRule.includes(',')) {
          var tempYearRule = yearRule.split(',')
          var result = parseInt('20' + serialNumber[parseInt(tempYearRule[0]) - 1] + serialNumber[parseInt(tempYearRule[1]) - 1])
          return result
        }
        //CONSTANT
        else if (yearRule == '0') {
          var result = 1981
          return result
        }
        else {
          var year = parseInt(serialNumber[parseInt(yearRule) - 1])
          var currentYear = moment().format('yyyy')
    
          // Yıl Hesaplama için yılın son hanesini gelen yıl kuralının yılından çıkarıyorum
          // Eğer Kalan negatif ise mevcut yılın son hanesine 10 ekliyip yıl kuralından çıkarıp onu da Bütün yıldan çıkarıyorum 
          // örnek: 8 geldi 2'den çıkarıyorum çünkü 2022, 2 - 8 = -6
          // -6 sıfırdan küçük olduğu için 2ye 10 ekliyorum ve 12 - 8 yapıyorum sonucum 4
          // bu elimde ki 4 ise 2022 den çıkarıyorum sonuç 2018
    
          if (parseInt(currentYear.substring(3)) - year < 0) {
            var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) + 10 - year)
            return result
          }
          else {
            var result = parseInt(currentYear) - (parseInt(currentYear.substring(3)) - year)
            return result
          }
        }
    }

    function calculateSerialNumberMonth(monthRule, serialNumber) {
        if (monthRule == null || monthRule == undefined) {
          return null
        }
        else if (monthRule.includes(',')) {
          var tempMonthRule = monthRule.split(',')
          var result = parseInt(serialNumber[parseInt(tempMonthRule[0]) - 1] + serialNumber[parseInt(tempMonthRule[1]) - 1])
          if (parseInt(result) > 12) {
            setUyariAciklamaNote(serialNumber + '-' + t('lblInvalidSerialNr'));
            setUyariTipCiktiNote('error');
            setUyariCiktiNote(true);
            return null;
          }
          return result
        }
        else if (monthRule.length == 1 && monthRule != '0') {
          var tempResult = serialNumber[parseInt(monthRule)-1]
          if (Number.isInteger(+tempResult)) {
            return tempResult
          }
          else if (tempResult == 'A') {
            return 10
          }
          else if (tempResult == 'B') {
            return 11
          }
          else if (tempResult == 'C') {
            return 12
          }
        }
        //CONSTANT
        else if (monthRule == '0') {
          var result = 1
          return result
        }
        else {
          return null
        }
    }

    function findOriginalSerialNumber(serialNumberRule, serialNumber) {
        if (serialNumberRule == null || serialNumberRule == undefined) {
          return null
        }
        else if (serialNumberRule.includes(',')) {
          var tempSerialNumberRule = serialNumberRule.split(',')
          if (parseInt(tempSerialNumberRule[1]) - serialNumber.length === 1) {
            var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
            return result
          }
          else if (serialNumber.length !== parseInt(tempSerialNumberRule[1])) {
            setUyariAciklamaNote(serialNumber + '-' + t('lblInvalidSerialNr'));
            setUyariTipCiktiNote('error');
            setUyariCiktiNote(true);
            return null;
          }
          else {
            var result = serialNumber.substr(parseInt(parseInt(tempSerialNumberRule[0])) - 1, parseInt(parseInt(tempSerialNumberRule[1])) - 1)
            return result
          }
        }
        else {
          return null
        }
    }

    const handleChangeBarcodeParse = Barcode => {

        setUyariCiktiNote(false);
        
        var Sku = SKU;
        var ProductYear = '';
        var ProductMonth = '';
        var SerialNr = '';
    
        if(SKU.length > 0){
          Sku = SKU;
        }
        else{
          setUyariAciklamaNote(t('lblSKUWarning'));
          setUyariTipCiktiNote('error');
          setUyariCiktiNote(true);
          return
        }
    
        if (Barcode === '9900000199')
       {
          ProductYear = '1981';
          SerialNr = '1';
          ProductMonth = '1';
          setUyariAciklamaNote(Barcode + '-' + t('lblDummySerialNrWarning'));
          setUyariTipCiktiNote('error');
          setUyariCiktiNote(true);
          setProductMonth(ProductMonth);
          setProductYear(ProductYear);
          setSerialNumber(SerialNr);
          return
        }
    
        if (SessionUser.TenantId === 59) {
          ProductYear = '1981';
          SerialNr = Barcode;
          ProductMonth = '1';
          setUyariAciklamaNote(Barcode + '-' + t('lblDummySerialNrWarning'));
          setUyariTipCiktiNote('error');
          setUyariCiktiNote(true);
          setProductMonth(ProductMonth);
          setProductYear(ProductYear);
          setSerialNumber(SerialNr);
          return
        }
        setLoading(true);
        axios
          .get(`/ControlSerialNumber/${Sku}/${0}/${Barcode}`)
          .then(response => {
            if (response.data) {
              var serialNumberYear = calculateSerialNumberYear(response.data.ProductionYearRule, Barcode)
              var serialNumberMonth = calculateSerialNumberMonth(response.data.ProductionMonthRule, Barcode)
              var wantedSerialNumber = findOriginalSerialNumber(response.data.SerialNumberRule, Barcode)
    
              if (serialNumberYear != null && serialNumberMonth != null && wantedSerialNumber != null) {
                setProductMonth(serialNumberMonth);
                setProductYear(serialNumberYear);
                setSerialNumber(wantedSerialNumber);
                setLoading(false);
                return;
              }

            }
            else {
              if (Barcode.length === 10) {
                ProductYear = '20' + Barcode.substring(0, 2);
                SerialNr = Barcode.substring(2, 8);
                ProductMonth = Barcode.substring(8, 10);
                setProductMonth(ProductMonth);
                setProductYear(ProductYear);
                setSerialNumber(SerialNr);
              }
              if (Barcode.length === 14 || Barcode.length === 18) {
                if (Barcode.length === 14) {
                  ProductYear = '202' + Barcode.substring(5, 6);
                  ProductMonth = Barcode.substring(6, 8);
                  SerialNr = Barcode.substring(8, 13);
                  setProductMonth(ProductMonth);
                  setProductYear(ProductYear);
                  setSerialNumber(SerialNr);
                }
                if (Barcode.length === 18) {
    
                  ProductYear = '20' + Barcode.substring(6, 8);
                  ProductMonth = Barcode.substring(14, 16);
                  SerialNr = Barcode.substring(9, 14);
                  setProductMonth(ProductMonth);
                  setProductYear(ProductYear);
                  setSerialNumber(SerialNr);
                }
              }
    
              setSerialParam(Barcode);
              if (SessionUser.TenantId !== 78) {
                if (
                  ProductYear === '' ||
                  ProductMonth === '' ||
                  SerialNr === '' ||
                  ProductYear === undefined ||
                  ProductMonth === undefined ||
                  SerialNr === undefined
                ) {
                  setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
                  setUyariTipCiktiNote('error');
                  setUyariCiktiNote(true);
                  ProductYear = '';
                  SerialNr = '';
                  ProductMonth = '';
                  setProductMonth(ProductMonth);
                  setProductYear(ProductYear);
                  setSerialNumber(SerialNr);
                }
                if (parseInt(ProductMonth) === 0 || parseInt(ProductMonth) > 12) {
                  setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
                  setUyariTipCiktiNote('error');
                  setUyariCiktiNote(true);
                  ProductYear = '';
                  SerialNr = '';
                  ProductMonth = '';
                  setProductMonth(ProductMonth);
                  setProductYear(ProductYear);
                  setSerialNumber(SerialNr);
                }
                if (
                  ProductYear.length !== 4 ||
                  parseInt(ProductYear) > parseInt(moment().format('yyyy'))
                ) {
                  setUyariAciklamaNote(Barcode + '-' + t('lblInvalidSerialNr'));
                  setUyariTipCiktiNote('error');
                  setUyariCiktiNote(true);
                  ProductYear = '';
                  SerialNr = '';
                  ProductMonth = '';
                  setProductMonth(ProductMonth);
                  setProductYear(ProductYear);
                  setSerialNumber(SerialNr);
                }
              }
            }
            setLoading(false);
          })
          .catch(error => {
            setLoading(false);
          });

        if (
          SessionUser.TenantId === 9
          || SessionUser.TenantId === 37
          || SessionUser.TenantId === 51
          || SessionUser.TenantId === 56
          || SessionUser.TenantId === 78
        ) {
          return;
        }    
    };


    function loadMaterialHistory() {
      GetHistoricalBom(SKU,ProductYear || 0,ProductMonth|| 0);
    }

    const uyariKapatCiktiNote = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setUyariCiktiNote(false);
    };

    return (
        <Card className={clsx(classes.root, className)}>
          {uyariCiktiNote ? (
            <Alert
              onClose={uyariKapatCiktiNote}
              open={uyariCiktiNote}
              message={uyariAciklamaNote || ''}
              variant={uyariTipCiktiNote}
            />
          ) : (
            <div />
          )}
          <Divider />
          <CardContent className={classes.content}>
            <div className={classes.wrapper}>
                <Grid container spacing={2}>
                    <Grid item xs={10}>
                        <TextField
                            disabled = {SKU ? false : true}
                            label={t('lblSerialNr')}
                            name="Barcode"
                            size="small"
                            value={SerialParam || ''}
                            fullWidth
                            onChange={e => setSerialParam(e.target.value)}
                            variant="outlined"
                        />
                        </Grid>
                        <Grid item xs={2}>
                        <Button
                            disabled = {SerialParam ? false : true}
                            disableElevation
                            variant="contained"
                            size="small"
                            color= {SerialParam ? 'primary' : 'gray'}
                            onClick={() => handleChangeBarcodeParse(SerialParam || '')}
                        >
                            <RepeatOneIcon />
                        </Button>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={4}>
                        <TextField
                        disabled
                        size="small"
                        id="ProductYear"
                        autoComplete="no"
                        value={ProductYear ? ProductYear : ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth
                        label={t('lblProductYear')}
                        variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                        disabled
                        size="small"
                        id="ProductMonth"
                        autoComplete="no"
                        value={ProductMonth ? ProductMonth : ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth
                        label={t('lblProductMonth')}
                        variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <TextField
                        disabled
                        size="small"
                        id="SerialNumber"
                        autoComplete="no"
                        value={SerialNumber ? SerialNumber : ''}
                        InputProps={{
                            readOnly: true,
                        }}
                        fullWidth
                        label={t('lblSerialNumber')}
                        variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4} lg={4}>
                        <Button
                          disabled = {SerialNumber !== '' ? false : true}
                          variant="contained"
                          style={{backgroundColor:SerialNumber !== '' ? '#B31312' : 'gray',color:'white'}}
                          size="small"
                          component="span"
                          onClick={() => loadMaterialHistory()}
                        >
                          {t('lblOk')}
                        </Button>
                      </Grid>
                </Grid>
            </div>
        </CardContent>
        </Card>
    );
}

const mapStateToProps = state => state;

const mapDispatchToProps = {
  resetMaterials,
  getMaterialRequest
};

export default connect(mapStateToProps
  , mapDispatchToProps
)(SerialNumberParse);